import "./style.scss";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import ProjectResourceItem from "../../components/ProjectResourceItem";
import { mainButton, popup } from "@telegram-apps/sdk";
import { useEffect, useState } from "react";
import ProjectResourceCartItem from "../../components/ProjectResourceCartItem";
import { Product } from "../../redux/types/Product";
import { useTariffAddProductsChargeMutation, useTariffAddProductsMutation } from "../../redux/api";
import { useLoadProjectTariff } from "../../hooks/useLoadProjectTariff";
import { navigateToPage, popRoute, setCheckoutMsg } from "../../redux/slices/windowSlice";

const ProjectChangeResourcesConfirm = () => {
    const dispatch = useAppDispatch();

    const { products, selectedProducts, projectId } = useAppSelector(
        (state: RootState) => state.windowSlice
    );

    const [loading, setLoading] = useState(true);

    const [charge, {data, isLoading, isError}] = useTariffAddProductsChargeMutation();
    const { loadProjectTariff, isLoading: isLoadingProjectTariff, data: projectTariff, isError: isErrorProjectTariff } = useLoadProjectTariff(projectId);

    useEffect(() => {
        mainButton.mount();
        mainButton.setParams({
            backgroundColor: "#3D88F7",
            hasShineEffect: true,
            isEnabled: true,
            isLoaderVisible: false,
            isVisible: false,
            text: "Оплатить",
            textColor: "#ffffff",
        });
        mainButton.onClick(() => {
            // dispatch(setProjectId(projectResources.project_id));
            // dispatch(navigateToPage("resources"));
            handleCharge();
            mainButton.setParams({
                isLoaderVisible: loading,
            });
            setLoading(!loading);
        });

        return () => {
            mainButton.setParams({
                isVisible: false,
            });
            mainButton.unmount();
        };
    }, []);

    useEffect(() => {
        if (!isLoadingProjectTariff && projectTariff && !isErrorProjectTariff) {
            dispatch(popRoute(2));
        } 
    }, [loadProjectTariff, projectTariff, isErrorProjectTariff, isLoadingProjectTariff]);
    
    const handleCharge = () => {
        charge({project_id: projectId}).unwrap()
            .then((response) => {
                loadProjectTariff();
                popup
                .open({
                    title: "Уведомление",
                    message: response.message,
                    buttons: [
                        { id: "my-id", type: "default", text: "Хорошо" },
                    ],
                })
            })
            .catch((error) => {
                dispatch(setCheckoutMsg(error.message));
            })
    };
    
    return (
        <div className="project-change-resources-confirm">
            <div className="project-change-resources-confirm_container">
                <div className="project-change-resources-confirm_wrapper">
                    <div className="project-change-resources-confirm_items">
                        {
                        products.map((product) => (
                                selectedProducts.selected_product_items.map((selectedProduct) => {
                                    if (product.items.find((item) => item.id === selectedProduct.product_item_id)) {                                    
                                        return (
                                            <span className="project-change-resources-confirm_item">
                                                {selectedProduct.count} x {product.title} 
                                            </span> 
                                        );
                                    }
                                })
                            ))
                        }
                    </div>                    
                    <div className="project-change-resources-confirm_details">
                        <div className="project-change-resources-confirm_details_paynow">
                            <span className="project-change-resources-confirm_details_paynow_text">
                                К оплате сейчас
                            </span>
                            {selectedProducts.total.map((total) => (
                                <span className="project-change-resources-confirm_details_paynow_item">
                                    {total.amount.toFixed(2)} {total.currency}
                                </span>
                            ))}                         
                        </div>
                        <div className="project-change-resources-confirm_details_paylater">
                            <span className="project-change-resources-confirm_details_paylater_text">
                                К оплате в следующем месяце
                            </span>
                            {selectedProducts.next_total.map((total) => (
                                <span className="project-change-resources-confirm_details_paylater_item">
                                    {total.amount.toFixed(2)} {total.currency}
                                </span>
                            ))}
                        </div>
                        <div className="project-change-resources-confirm_details_next-charge">
                            <span className="project-change-resources-confirm_details_next-charge_text">
                                Следующий платеж
                            </span>
                            <span className="project-change-resources-confirm_details_next-charge_item">
                                {new Date(selectedProducts.next_charge_date).toLocaleString('ru-RU', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}
                            </span>
                        </div>
                    </div>
                    
                </div>
                <button className="pay" onClick={handleCharge}>
                        ОПЛАТИТЬ 
                    </button>
            </div>
        </div>
    );
};

export default ProjectChangeResourcesConfirm;
